export default __webpack_public_path__ + "static/media/centris_data_transfer_profile_button_en.b54844b2.png";